export const QUERY_PROMISSORIES = 'QUERY_PROMISSORIES';
export const OPEN_QUERY_PROMISSORY_MODAL = 'OPEN_QUERY_PROMISSORY_MODAL';
export const CLOSE_QUERY_PROMISSORY_MODAL = 'CLOSE_QUERY_PROMISSORY_MODAL';
export const RESET_QUERY_DATA = 'RESET_QUERY_DATA';
export const SET_AVAILABLE_QUOTA = 'SET_AVAILABLE_QUOTA';